/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PDFReportMapSettingsDto } from './pDFReportMapSettingsDto';

export interface PDFReportCreateDto {
  mapSettings?: PDFReportMapSettingsDto;
  reseller?: string;
  withComments?: boolean;
  withCosts?: boolean;
  withDriver?: boolean;
  withFields?: boolean;
  withFuel?: boolean;
  withHours?: boolean;
  withMap?: boolean;
}
